module.exports = __webpack_public_path__ + "static/img/ddhzyk-img2.b7682922.jpg";